import router from '../router';
import * as ls from 'local-storage';

//
const basket = {
  namespaced: true,
  state: {
    items: [],
    voucher: {
      price_with_discount: null,
      price: null,
      price_per_person: null,
      recipe_book: false,
      code: null
    },
    customer: {
      forename: "",
      surname: "",
      email: "",
      password: ""
    },
    delivery: {
      address1: "",
      address2: "",
      city: "",
      postcode: "",
      tel: "",
      notes: ""
    },
    config: {
      max_count: 1,
      min_count: 0
    }
  },
  mutations: {
    addItem(state, item) {
      state.items.push(item);
      ls.set('basket.previous_recipes', state.items.map(v => {
        return v.recipe.id;
      }));
    },
    removeItem(state, item) {
      state.items.splice(state.items.indexOf(item), 1);
      ls.set('basket.previous_recipes', state.items.map(v => {
        return v.recipe.id;
      }));
    },
    removeAllFromBasket(state, item) {
      state.items = state.items.reduce((a, c) => {
        if (c.recipe.id != item.id) {
          a.push(c);
        }
        return a;
      }, [])
    },
    setVoucher(state, voucher) {
      if (state.items.length >= state.config.min_count) {
        state.voucher = voucher;
      } else {
        state.voucher.code = null;
        state.voucher.price = null;
        state.voucher.price_with_discount = null;
        state.voucher.price_per_person = null;
        state.voucher.recipe_book = null;
      }
    },
    unApplyVoucher(state) {
      state.voucher.code = null;
      state.voucher.price = null;
      state.voucher.price_with_discount = null;
      state.voucher.price_per_person = null;
      state.voucher.recipe_book = null;
    },
    applyDeliveryAddress(state, newAddress) {
      state.delivery = Object.assign(state.delivery, newAddress);
    },
    configure(state, config) {
      if (config.min_count) {
        state.config.max_count = config.max_count;
      }
      if (config.max_count) {
        state.config.min_count = config.min_count;
      }
    },
    updateBasketItemPortions(state, people) {
      state.items.map(v => {
        v.people = people;
        return v;
      })
    },
    updateUrlParams(state) {
      router.replace({
        query: {
          selected_recipes: state.items.map(v => v.recipe.id).join(',')
        }
      })
    }
  },
  actions: {
    applyDeliveryAddress({
      commit
    }, item) {
      commit('applyDeliveryAddress', item);
    },
    async removeItem({
      commit, dispatch
    }, item) {
      commit("removeItem", item);
      const payload = await dispatch('transFormRecipeToGA', item);
      dispatch("trackAnalytics", { action: 'trackRemoveFromCart', payload });
      dispatch("updateDiscount");
      return item;
    },
    async removeAllFromBasket({
      commit, dispatch
    }, recipe) {
      commit("removeAllFromBasket", recipe);
      dispatch("updateDiscount");
      commit("updateUrlParams");
    },
    async emptyBasket({
      state, dispatch, commit
    }) {
      const items = [...state.items];
      if (state.items.length > 0) {
        ls.set('basket.lastbasket_recipes', state.items.map(v => {
          return v.recipe.id;
        }));
      }
      items.forEach(async item => {
        const removed = await dispatch('removeItem', item);
      });
      commit("updateUrlParams");
    },
    async updateBasketItemPortions({
      commit
    }, people) {
      commit('updateBasketItemPortions', people)
    },
    async updateDiscount({
      commit,
      state,
      dispatch
    }) {
      if (state.items.length >= 1) {
        const data = await dispatch('voucher/applyVoucher', {
          code: state.items[0].voucher,
          delivery_weekday: state.items[0].shipping_run_day,
          shipping_run: state.items[0].shipping_run,
          recipe_ids: state.items.map(v => v.recipe.id),
          portion_count: state.items[0].people
        }, { root: true });
        commit('setVoucher', data);
      }
    },
    async addItem({
      commit, dispatch
    }, item) {
      commit("addItem", item);
      const payload = await dispatch('transFormRecipeToGA', item);
      dispatch("trackAnalytics", { action: 'trackAddToCart', payload });
      const discount = await dispatch("updateDiscount");
      commit("updateUrlParams");
      return item;
    },
    async updateAnalyticsCheckoutProgress({
      state, dispatch
    }) {
      const items = [...state.items];
      const affiliation = items[0].affiliation;
      const coupon = state.voucher.code;

      const payload = {
        items: items.map(item => {
          const recipe = item.recipe;
          return {
            "id": recipe.id,
            "name": recipe.title.toLowerCase(),
            "category": recipe.food_group.toLowerCase(),
            "price": item.price,
            "quantity": 1,
            "list_name": item.list,
            "list_position": item.list_position,
            "position": item.list_position,
            "dimension2": item.meal_plan ? item.meal_plan.toLowerCase() : 'unknown',
            "dimension3": item.people,
            "dimension4": item.shipping_run,
            "dimension5": item.shipping_run_day,
            "dimension6": item.shipping_run_date,
          }
        }),
        affiliation,
        coupon
      };

      return dispatch("trackAnalytics", {
        action: 'trackCheckoutProgress',
        payload
      });
    },
    async setVoucher({
      commit, dispatch
    }, code) {
      commit("setVoucher", code);
      dispatch("updateAnalyticsCheckoutProgress");
    },
    async unApplyVoucher({
      commit
    }) {
      commit("unApplyVoucher");
    },
    async transFormRecipeToGA({
      dispatch
    }, item) {
      const recipe = item.recipe;
      return recipe ? {
        "id": recipe.id,
        "name": recipe.title.toLowerCase(),
        "category": recipe.food_group.toLowerCase(),
        "price": item.price,
        "quantity": 1,
        "list_name": item.list,
        "list_position": item.list_position,
        "position": item.list_position,
        "dimension2": item.meal_plan ? item.meal_plan.toLowerCase() : 'unknown',
        "dimension3": item.people,
        "dimension4": item.shipping_run,
        "dimension5": item.shipping_run_day,
        "dimension6": item.shipping_run_date,
      } : null
    },
    trackAnalytics({
      dispatch
    }, data) {
      if (data.payload)
        dispatch(`analytics/${data.action}`, data.payload, { root: true });
    },
    async configure({ dispatch, commit }, options) {
      if (options.people) {
        const minMax = await dispatch('configuration/getValue', 'basketLimits', { root: true });
        minMax.split(';').map(v => {
          const p = v.split('|');
          if (p[0] == options.people) {
            const setting = JSON.parse(p[1])
            commit('configure', setting);
          }
        })
      }
    }
  },
  getters: {
    total: state => people => {
      const voucher = state.voucher;
      if (voucher.price_with_discount != null && (state.items.length >= state.config.min_count)) {
        return voucher.price_with_discount;
      }
      const t = state.items.reduce((p, c) => {
        if (c.recipe) {
          const portionPrice = (c.recipe.fractional_prices_for_portions[people] / 100)
          return p + (portionPrice)
        }
        return p + c.price;
      }, 0);
      return t;
    },
    last_added_item(state) {
      return state.items.length > 0 ? state.items[state.items.length - 1] : null;
    },
    size(state) {
      return state.items.length;
    },
    ready(state) {
      return (state.items.length >= state.config.min_count) && (state.items.length <= state.config.max_count);
    },
    item_ids(state) {
      return state.items.map(v => v.recipe.id).join(',');
    }
  }
};

export default basket;